const containerName = import.meta.env.VITE_ASSISTANT_STORAGE_CONTAINER_NAME;
export const isAssistantLogoOnContainer = (image: string): boolean => {
  // Check if the image URL contains the container name
  return image.includes(containerName);
};
